import Svg from '@doordash/component-svg'
import * as React from 'react'

// tslint:disable:max-line-length
export const Van: React.FunctionComponent = () => (
  <Svg
    width={147}
    height={146}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path
      d="M137.707 93.404l-10.283 2.786-13.712-.428-8.998-3s5.142-14.354 5.571-14.996c.428-.643 10.069-1.715 10.069-1.715l9.426 1.072 5.142 4.712 2.785 11.57zM50.299 93.619l-11.57 2.356-22.281-4.927 5.142-15.425s9.212-1.928 9.855-1.928c.643 0 11.997 2.356 11.997 2.356l5.571 5.142L50.3 93.619z"
      fill="#204A51"
    />
    <path
      d="M89.719 46.272c3.428.428 6.212.536 10.926 3.535s19.818 12.318 20.888 13.176c1.071.857 11.569 4.178 16.818 7.07 3.207 1.766 5.784 4.499 5.999 8.355.215 3.856 2.999 5.57 2.356 7.284-.643 1.714-2.999 8.355-6.212 9.855-3.214 1.5-5.357 1.5-6.213 1.285-.857-.214 2.142-8.14-2.571-13.282-2.67-2.913-7.07-4.928-10.713-4.5-3.641.429-8.783.644-10.711 6.642-1.929 5.999-1.286 10.283-1.714 10.712-.429.428-20.942-.429-29.298-.642-7.757-.2-35.189 0-35.189 0s2.68-10.927-2.892-14.783c-5.57-3.856-8.998-3.643-12.212-2.892-4.84 1.128-7.82 3.748-9.32 7.391-1.498 3.642-1.285 8.14-1.285 8.14s-13.71-2.142-15.21-2.355c-1.5-.215-.858-4.714-.428-5.572.428-.856-1.072-4.284-.43-7.283.643-3 1.072-17.781 2.358-22.923 1.285-5.142 3.856-8.249 6.427-9.106 2.57-.856 29.779-2.035 46.49-1.714 14.138.271 32.136 1.607 32.136 1.607z"
      fill="#528C8F"
    />
    <path
      d="M128.739 83.984s-7.042-4.27-11.573-1.282c-4.531 2.986-6.953 7.882-6.042 11.626.911 3.745 3.398 6.955 7.663 7.668 4.265.714 9.508-.49 11.33-4.702 1.821-4.215 2.176-5.998 1.465-8.494-.961-3.378-2.843-4.816-2.843-4.816z"
      fill="#3A646E"
    />
    <path
      d="M115.305 91.408s.667 4.62 3.684 5.744c3.017 1.123 5.999.89 7.445-.915 1.445-1.805 2.079-4.185.904-6.523-1.175-2.338-3.602-4.457-6.237-3.814-2.635.644-3.603 1.119-4.53 2.373-1.255 1.696-1.266 3.135-1.266 3.135z"
      fill="#8BA4AA"
    />
    <path
      d="M39.02 83.136s-7.122-4.32-11.704-1.298c-4.583 3.02-7.031 7.97-6.11 11.759.92 3.787 3.436 7.032 7.75 7.755 4.313.72 9.615-.496 11.457-4.758 1.844-4.26 2.202-6.064 1.482-8.589-.973-3.415-2.875-4.87-2.875-4.87z"
      fill="#3A646E"
    />
    <path
      d="M25.43 90.642s.675 4.673 3.725 5.81c3.051 1.136 6.067.9 7.53-.926 1.462-1.825 2.103-4.232.914-6.597-1.188-2.364-3.642-4.507-6.306-3.856-2.668.65-3.646 1.13-4.583 2.398-1.269 1.715-1.28 3.171-1.28 3.171z"
      fill="#8BA4AA"
    />
    <path
      d="M120.67 64.482c-1.928 1.5-3.32 1.019-3.963.59-.643-.429-8.388-5.388-11.784-8.088-4.177-3.321-10.926-7.07-10.926-7.07s3.428-1.178 4.07-1.393c.644-.213 5.677 3.107 10.391 6.106 4.714 3 12.909 8.355 12.909 8.355l-.697 1.5z"
      fill="#D2EDF3"
    />
    <path
      d="M80.289 51.2c-1.023.382-1.07 2.356-.643 4.713.428 2.356 1.607 12.533 1.607 12.533l22.389 1.607-.643-10.713s-6.642-4.712-9.213-5.998c-2.57-1.285-11.784-2.785-13.497-2.143z"
      fill="#E2F3F7"
    />
    <mask
      id="a"
      maskUnits="userSpaceOnUse"
      x="79"
      y="51"
      width="25"
      height="20"
    >
      <path
        d="M80.289 51.2c-1.023.382-1.07 2.356-.643 4.713.428 2.356 1.607 12.533 1.607 12.533l22.389 1.607-.643-10.713s-6.642-4.712-9.213-5.998c-2.57-1.285-11.784-2.785-13.497-2.143z"
        fill="#E2F3F7"
      />
    </mask>
    <g opacity=".86" mask="url(#a)">
      <path
        opacity=".86"
        d="M99.933 62.9l-.131 7 1.487.19s-.181-6.33-.049-6.782c.132-.452-1.307-.408-1.307-.408z"
        fill="#A9D7E0"
      />
      <path
        opacity=".86"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M90.525 56.192c-.2-1.004-.718-1.25-1.772-1.377-1.561-.188-2.26 1.395-2.463 2.316-.203.92.004 1.675.506 2.616.113.213.218.37.317.491-.069.219-.095.499-.047.857.06 1.138-.693 3.486-.693 3.486s1.69.423 2.45.11c-.407-1.392-.376-3-.351-3.547.688.28 1.734.298 2.135-.433.235-.428.174-1.72.174-1.72s.403.065.374-.15a1.275 1.275 0 00-.089-.288 3.157 3.157 0 01-.184-.629c-.045-.247-.076-.39-.122-.602-.05-.227-.116-.533-.235-1.13z"
        fill="#C0E0E9"
      />
      <path
        opacity=".86"
        d="M90.53 55.577c-.056.868-.218 3.354-1.555 4-1.851.897-1.402 4.194-2.449 5.145-1.113 1.013-3.234 1.882-5.396.15-.86-.689-1.234-3.4.486-4 1.72-.599 1.806-.217 2.353-1.276.548-1.058-.13-2.09.148-3.477.34-1.687 1.36-2.794 2.474-2.95 1.195-.169 4.046.78 3.94 2.408z"
        fill="#A9D7E0"
      />
      <path
        opacity=".86"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M84.74 66.385c-.92 1.942-.111 4.632-.111 4.632l.45 2.684c-.164 1.3-.683 6.39-.683 6.39s1.758-.259 2.868.115c1.108.374 3.884.555 4.07 0 .139-.408-.044-1.628-.205-2.698-.057-.382-.112-.746-.148-1.046-.05-.423-.12-.888-.188-1.349-.134-.899-.265-1.785-.252-2.323l.718 1.092c.467.709 1.908 1.076 2.587.274.442-.52 3.586-3.536 5.62-5.478l.074.048s1.408-.934 1.767-1.374c.24-.294.187-.709.144-1.053-.022-.171-.041-.325-.022-.438.022-.131.112-.312.21-.508.155-.313.331-.665.285-.923-.073-.419-1.233.14-1.468.311-.068.05-.19.126-.336.216-.364.226-.877.544-1.08.788-.175.213-.224.529-.268.826-1.394 1.17-3.636 3.06-4.318 3.687-.507.465-.697.69-.792.802a.4.4 0 01-.105.103.36.36 0 01-.118.025c-.165.021-1.408-.917-2.258-1.577a12.524 12.524 0 00-.305-1.448c-.238-.84-1.067-3.442-2.065-3.614a1.974 1.974 0 00-.074-.012l-.036-.006c-.397-.249-1.752-.479-2.422-.263-.815.265-1.539 2.117-1.539 2.117z"
        fill="#A9D7E0"
      />
    </g>
    <path
      d="M113.067 70.481l-9.426-.428-.643-10.713s8.356 7.5 9.426 8.355c1.071.858.643 2.786.643 2.786z"
      fill="#3A646E"
    />
    <path
      d="M72.36 51.2c1.5.857 1.285.214 1.928 4.284.643 4.07 1.928 11.569.857 12.105-1.713.857-12.426-.75-17.139-.964-4.713-.215-30.422-2.143-33.421-2.143-3 0-11.784-.428-11.784-.428s3-7.07 4.285-9.213c1.285-2.142 1.511-3.678 6.213-4.07 5.142-.429 21.638-.642 33.207-.214 4.09.151 15.854.642 15.854.642z"
      fill="#E2F3F7"
    />
    <path
      d="M46.226 50.129l-.215 15.746-5.355-.107 1.82-15.533 3.75-.106z"
      fill="#3A646E"
    />
    <path
      d="M7.77 50.932L5.844 63.626h-2.25s.271-8.267 2.57-12.293c.644-1.124 1.608-.401 1.608-.401z"
      fill="#E2F3F7"
    />
    <path
      d="M82.647 72.624c.425.122 2.932.191 4.54 0 1.61-.193 1.136-1.174 1.136-1.174h-5.676s-.426 1.05 0 1.174z"
      fill="#93AAAF"
    />
    <path
      opacity=".4"
      d="M143.512 74.197s-8.831-1.594-9.291-1.02c-.458.573 3.319 3.693 4.306 5.236.986 1.544 2.712 1.544 3.945 1.544 1.233 0 3.088.335 3.335-.592.246-.925-2.295-5.168-2.295-5.168z"
      fill="#FEFF58"
    />
    <path
      opacity=".4"
      d="M5.836 63.626s1.928 13.176.643 14.14C5.193 78.73.802 78.3.802 78.3S2.73 63.84 2.088 63.52c-.643-.321 3.748.107 3.748.107z"
      fill="#EB1700"
    />
    <path
      d="M85.974 78.083c.459.909.31 1.517 1.07 2.272.763.754 1.22 1.208 1.674 1.205.455-.001 3.335-.319 5.002-.325 1.668-.008 3.032-.014 3.188.743.154.759.157 1.215-1.055 1.372-1.213.157-3.791.015-4.245.17-.454.154-2.122.01-1.361.764.762.756 2.452 2.652 2.93 2.604.796-.08 3.745-.115 4.813-.21 1.78-.16 3.284-3.125 3.164-4.566-.121-1.435-1.534-3.939-3.202-4.083-1.669-.144-6.52-.122-7.582-.117-1.062.004-4.396.171-4.396.171z"
      fill="#EB1700"
    />
    <path
      d="M89.084 79.183a.538.538 0 01.56.532c.002.3-.159.528-.474.532l-.384.032c-.016 0-.052-.08-.052-.095l-.002-.98c0-.015.011-.026.026-.026l.326.005zm-.167.208l.007.662.168-.001a.327.327 0 00.32-.333l.01-.062c.004-.177-.148-.263-.324-.267h-.013l-.168.001zM93.808 79.069c.315-.004.518.201.521.502.004.3-.157.529-.472.531l-.385.031c-.014.001-.052-.078-.052-.094l-.002-.98c0-.015.012-.026.027-.026l.363.036zm-.249.181l.052.658.194-.03c.18-.002.298-.124.294-.304l.01-.06c.004-.18-.148-.264-.325-.268h-.012l-.213.004zM90.388 79.118c.149-.003.248.06.35.136a.609.609 0 01.233.4c.044.304-.249.563-.58.567-.33.002-.619-.25-.59-.556.03-.303.206-.545.537-.547h.05zm-.036.911a.664.664 0 00.25-.041c.1-.055.16-.183.138-.333-.028-.193-.162-.352-.357-.35-.196 0-.412.14-.41.336.002.197.16.378.356.377M91.683 80.242c-.15.002-.249-.06-.352-.137a.603.603 0 01-.232-.399c-.044-.304.25-.564.58-.567.33-.003.618.249.59.556-.03.302-.206.544-.536.546l-.05.001zm.035-.912a.664.664 0 00-.25.04c-.102.056-.16.183-.138.334.029.193.162.352.356.35.196 0 .413-.14.41-.336 0-.196-.16-.378-.356-.377M92.35 79.137c0-.016.012-.027.027-.027l.407.006c.214-.001.368.136.37.333a.34.34 0 01-.196.308l.183.308c.007.011-.016.092-.027.1a.029.029 0 01-.017.005l-.127.003a.029.029 0 01-.025-.014l-.12-.354-.282-.005.032.36a.026.026 0 01-.027.027l-.123.005c-.016.001-.027-.012-.027-.026l-.048-1.03zm.38.132l-.223.013.035.31.241.028c.077.004.209-.098.211-.175 0-.002-.005.001-.005 0 .002-.078-.136-.17-.214-.172h-.028M94.644 79.885l-.084.236a.028.028 0 01-.027.018l-.136.004c-.016.001-.029-.01-.03-.023a.025.025 0 01.001-.014l.348-1.012a.026.026 0 01.027-.018l.204-.018a.026.026 0 01.027.018l.158.45.224.573c.008.013.001.028-.012.035a.026.026 0 01-.014.004l-.157-.005a.026.026 0 01-.027-.017l-.105-.288-.397.056zm.185-.58s-.14.371-.11.379c.03.008.259-.035.259-.035l-.15-.344zM95.517 79.362c.051-.17.142-.317.374-.319a.47.47 0 01.335.125.026.026 0 010 .039l-.094.096c-.009.012-.027.012-.037.001-.049-.043-.126-.11-.193-.11-.091 0-.155.105-.154.167.001.2.644.085.61.455-.016.19-.204.35-.466.35a.543.543 0 01-.39-.15c-.011-.011-.011-.029 0-.038v-.001l.05-.075a.027.027 0 01.038-.002h.001c.063.061.193.093.28.093.116 0 .24-.1.256-.176.027-.133-.608-.068-.61-.453M97.204 79.16l-.032.404-.478.02.013-.416c0-.016-.012-.029-.026-.029h-.001l-.175.002c-.015 0-.01.09-.01.103l.001.051-.004.856c-.001.014.012.027.026.027h.001l.175-.001a.027.027 0 00.027-.027v-.001l-.014-.414.467.038.003.409c0 .016.01.027.026.027h.117c.016.001.028-.009.028-.024v-.003l.05-1.022a.027.027 0 00-.025-.028h-.14c-.016 0-.029.01-.029.025v.003z"
      fill="#fff"
    />
  </Svg>
)

export default Van
